import { ComponentType } from 'react';

import styled from 'styled-components';

import { Card } from '@components/card';
import { IconProps } from '@components/icons';

import { Badge } from '../badge';
import { Text } from '../text';

export interface IntegrationCardProps {
  icon: ComponentType<IconProps>;
  header: string;
  text: string;
  tag?: string;
}

export function IntegrationCard(props: IntegrationCardProps) {
  const { icon: Icon, header, text, tag } = props;
  return (
    <Card space={4}>
      <IconTagContainer>
        <Icon size={40} color="elementPurpleInvert" />
        {tag && <Badge variant="green" size="md" text={tag} />}
      </IconTagContainer>
      <Text font="bold16" text={header} />
      <Text font="regular14" text={text} />
    </Card>
  );
}

const IconTagContainer = styled.div({
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: '0.5rem',
});
